/**
 * Clés de stockage d'avant le renommage en belvdr (`belvedere:…`) : leur état est repris sous
 * les nouvelles clés, puis elles sont effacées. Un visiteur garde ainsi son identité, sa session
 * active et son onglet à travers la mise à jour du SDK.
 */

/**
 * Reprend la valeur de `legacyKey` sous `key` si `key` est absente (une valeur invalide est
 * ignorée à la lecture, comme toute autre), puis efface `legacyKey`. Stockage inaccessible ou
 * plein : rien n'est repris, l'ancienne clé reste pour un prochain essai.
 */
export function migrateLegacyKey(storage: Storage, legacyKey: string, key: string): void {
  try {
    const value = storage.getItem(legacyKey)
    if (value === null) return
    if (storage.getItem(key) === null) storage.setItem(key, value)
    storage.removeItem(legacyKey)
  } catch {
    // Rien de repris.
  }
}
